var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import useAppSelector from '@/hooks/useAppSelector';
import { getLocale } from '@/utils/helpers';
const loadMessages = (locale) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const lowerLocale = locale.toLowerCase();
    try {
        const [commonMessages, projectMessages] = yield Promise.all([
            import(`./locales/${lowerLocale}/common.json`),
            import(`./locales/${lowerLocale}/${lowerLocale}.json`)
        ]);
        return Object.assign(Object.assign({}, ((_a = commonMessages.default) !== null && _a !== void 0 ? _a : commonMessages)), ((_b = projectMessages.default) !== null && _b !== void 0 ? _b : projectMessages));
    }
    catch (_c) {
        return {};
    }
});
const LocaleProvider = ({ children }) => {
    const [localeMessages, setLocaleMessages] = useState({});
    const userLang = useAppSelector((state) => state.auth.user.lang);
    const locale = getLocale(userLang);
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            const data = yield loadMessages(locale);
            setLocaleMessages(data);
        });
        void fetchData();
    }, [locale]);
    const checkMessages = Object.keys(localeMessages).length;
    return (checkMessages
        ? (React.createElement(IntlProvider, { defaultLocale: "en", locale: locale === 'TG' ? 'ru' : locale.toLowerCase(), messages: localeMessages }, children))
        : React.createElement(React.Fragment, null));
};
export default LocaleProvider;
